import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
  Image,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../interfaces/State";
import { setIsOpenSWW } from "../../reducers/global/globalSlice";
import { resetError as resetErrorSelfie } from "../../reducers/selfie/selfieSlice";
import { resetError as resetErrorStyles } from "../../reducers/style/styleSlice";
import { resetError as resetErrorVolumeColor } from "../../reducers/volume/volumeSlice";

export const SomethingWentWrongDialog = () => {
  const { isOpenSWW } = useSelector((state: State) => state.global);
  const cancelRef = useRef(null);
  const dispatch = useDispatch();

  const onClickGotIt = () => {
    dispatch(setIsOpenSWW(false));
    dispatch(resetErrorSelfie());
    dispatch(resetErrorStyles());
    dispatch(resetErrorVolumeColor());
  };

  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={cancelRef}
      onClose={onClickGotIt}
      isOpen={isOpenSWW}
      isCentered
      closeOnOverlayClick={false}
      closeOnEsc={false}
    >
      <AlertDialogOverlay />
      <AlertDialogContent className="AlertDialogContentTdC">
        <VStack justifyContent={{ base: "center", md: "center" }}>
          <Image
            mt={{ base: "1.5rem", md: "2.125rem" }}
            mb={{ base: "0.625rem", md: "0.875rem" }}
            src={
              process.env.PUBLIC_URL + "/assets/images/Exclamation-triangle.svg"
            }
            width={{ base: "3.3125rem", md: "3.625rem" }}
            height={{ base: "3.3125rem", md: "3.625rem" }}
          />
          <Text
            fontWeight={{ base: "bold", md: "bold" }}
            fontSize={{ base: "1rem", md: "1.125rem" }}
            letterSpacing={{ base: "0.0156rem", md: "0.0225rem" }}
            pb="0"
            justifyContent={{ base: "center", md: "center" }}
            textAlign={{ base: "center", md: "center" }}
            color="#000"
          >
            Oops!
          </Text>
          <Text
            fontSize={{ base: "0.75rem", md: "0.75rem" }}
            textAlign={{ base: "center", md: "center" }}
            justifyContent={{ base: "center", md: "center" }}
            px={{ base: "1.5rem", md: "2.125rem" }}
            color="#000"
          >
            Something went wrong. Please try again.
          </Text>
        </VStack>
        <VStack
          justifyContent="center"
          pb="20px"
          flexDirection="row"
          pt="0"
          gap={{ base: "0.875rem", md: "1.25rem" }}
          mt={{ base: "1.5rem", md: "2.125rem" }}
        >
          <Button
            fontSize={{ base: "0.75rem", md: "0.9375rem" }}
            border="0.0625rem solid #000000"
            color={"white"}
            bg="black"
            _hover={{
              bg: "black",
            }}
            px={{ base: "1.5rem", md: "1.5rem" }}
            py={{ base: "0.625rem", md: "0.9375rem" }}
            onClick={onClickGotIt}
          >
            Got it!
          </Button>
        </VStack>
      </AlertDialogContent>
    </AlertDialog>
  );
};
